<!-- 状态信息 -->
<template>
  <j-modal :title="title" v-dragModal :width="1000" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{  overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <a-tabs default-active-key="1" @change="callback">
        <a-tab-pane key="1" :tab="$t('蓄电池信息')">
          <!-- <a-table
            ref="table"
            size="middle"
            :scroll="{x:true}"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange">
          </a-table> -->
          <detail-list :col="3">
            <detail-list-item :term="$t('设备编号')">{{model.meterId}}</detail-list-item>
            <detail-list-item :term="$t('压力状态')">{{[$t('正常'),$t('超压(过压保护)'),$t('欠压'),$t('过放')][model.pressureState]}}</detail-list-item>
            <detail-list-item :term="$t('温度状态')">{{[$t('正常'),$t('高温保护')][model.temperatureState]}}</detail-list-item>
            <detail-list-item :term="$t('创建时间')">{{model.createTime}}</detail-list-item>
          </detail-list>
        </a-tab-pane>
        <a-tab-pane key="2" :tab="$t('充电信息')">
          <!-- <a-table
            ref="table"
            size="middle"
            :scroll="{x:true}"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange">
          </a-table> -->
          <detail-list :col="3">
            <detail-list-item :term="$t('设备编号')">{{model.meterId}}</detail-list-item>
            <detail-list-item :term="$t('充电设备状态')">{{[$t('正常'),$t('故障')][model.chargingMeterState]}}</detail-list-item>
            <detail-list-item :term="$t('充电状态')">{{[$t('未充电'),$t('浮充'),$t('强充'),$t('均衡充')][model.chargingState]}}</detail-list-item>
            <detail-list-item :term="$t('昼夜状态')">{{[$t('白天'),$t('夜晚')][model.dayNightState]}}</detail-list-item>
            <detail-list-item :term="$t('是否使用')">{{[$t('未充电'),$t('正在充电')][model.isUse]}}</detail-list-item>
            <detail-list-item :term="$t('设备状态')">{{[$t('正常'),$t('充电过温')][model.meterState]}}</detail-list-item>
            <detail-list-item :term="$t('创建时间')">{{model.createTime}}</detail-list-item>
          </detail-list>
        </a-tab-pane>
        <a-tab-pane key="3" :tab="$t('放电信息')">
          <!-- <a-table
            ref="table"
            size="middle"
            :scroll="{x:true}"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange">
          </a-table> -->
          <detail-list :col="3">
            <detail-list-item :term="$t('设备编号')">{{model.meterId}}</detail-list-item>
            <detail-list-item :term="$t('是否放电')">{{[$t('未放电'),$t('正在放电')][model.isDischarging]}}</detail-list-item>
            <detail-list-item :term="$t('是否硬件保护')">{{[$t('正常'),$t('硬件保护')][model.isHardwareProtection]}}</detail-list-item>
            <detail-list-item :term="$t('是否开路保护')">{{[$t('正常'),$t('开路保护')][model.isOpenCircuitProtection]}}</detail-list-item>
            <detail-list-item :term="$t('是否过温')">{{[$t('正常'),$t('放电过温')][model.isOvertemperature]}}</detail-list-item>
            <detail-list-item :term="$t('是否短路保护')">{{[$t('正常'),$t('短路保护')][model.isShortCircuitProtection]}}</detail-list-item>
            <detail-list-item :term="$t('设备输出功率')">{{[$t('轻载'),$t('中度'),$t('额定'),$t('过载')][model.meterOutputPowerState]}}</detail-list-item>
            <detail-list-item :term="$t('设备状态')">{{[$t('正常'),$t('故障')][model.meterState]}}</detail-list-item>
            <detail-list-item :term="$t('创建时间')">{{model.createTime}}</detail-list-item>
          </detail-list>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  export default {
    // mixins: [JeecgListMixin],
    name: 'modal',
    components: {
      DetailList,
      DetailListItem
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        // 表头
        columns: [],
        // columns1: [
        //   {
        //     title: '#',
        //     dataIndex: '',
        //     key:'rowIndex',
        //     width:60,
        //     align:"center",
        //     customRender:function (t,r,index) {
        //       return parseInt(index)+1;
        //     }
        //   },
        //   {
        //     title: '设备编号',
        //     dataIndex: 'meterId',
        //     align:"center",
        //   },
        //   {
        //     title:'压力状态',
        //     align:"center",
        //     dataIndex: 'pressureState',
        //     customRender:function (t,r,index) {
        //       if(t == 0){
        //         return '正常';
        //       }else if(t == 1){
        //         return '超压(过压保护)'
        //       }else if(t == 2){
        //         return '欠压'
        //       }else if(t == 3){
        //         return '过放'
        //       }
        //     }
        //   },
        //   {
        //     title:'温度状态',
        //     align:"center",
        //     dataIndex: 'temperatureState',
        //     customRender:function (t,r,index) {
        //       if(t == 0){
        //         return '正常';
        //       }else if(t == 1){
        //         return '高温保护'
        //       }
        //     }
        //   },
        //   {
        //     title:'创建时间',
        //     align:"center",
        //     dataIndex: 'createTime',
        //   },
        // ],
        // columns2: [
        //   {
        //     title: '#',
        //     dataIndex: '',
        //     key:'rowIndex',
        //     width:60,
        //     align:"center",
        //     customRender:function (t,r,index) {
        //       return parseInt(index)+1;
        //     }
        //   },
        //   {
        //     title:'设备id',
        //     align:"center",
        //     dataIndex: 'meterId'
        //   },
        //   {
        //     title:'充电设备状态',
        //     align:"center",
        //     dataIndex: 'chargingMeterState',
        //     customRender:function (t,r,index) {
        //       if(t == 0){
        //         return '正常';
        //       }else if(t == 1){
        //         return '故障'
        //       }
        //     }
        //   },
        //   {
        //     title: '充电状态',
        //     dataIndex: 'chargingState',
        //     align:"center",
        //     customRender:function (t,r,index) {
        //       if(t == 0){
        //         return '未充电';
        //       }else if(t == 1){
        //         return '浮充'
        //       }else if(t == 2){
        //         return '强充'
        //       }else if(t == 3){
        //         return '均衡充'
        //       }
        //     }
        //   },
        //   {
        //     title:'昼夜状态',
        //     align:"center",
        //     dataIndex: 'dayNightState',
        //     customRender:function (t,r,index) {
        //       if(t == 0){
        //         return '白天';
        //       }else if(t == 1){
        //         return '夜晚'
        //       }
        //     }
        //   },
        //   {
        //     title:'是否使用',
        //     align:"center",
        //     dataIndex: 'isUse',
        //     customRender:function (t,r,index) {
        //       if(t == 0){
        //         return '未充电';
        //       }else if(t == 1){
        //         return '正在充电'
        //       }
        //     }
        //   },
        //   {
        //     title:'设备状态',
        //     align:"center",
        //     dataIndex: 'meterState',
        //     customRender:function (t,r,index) {
        //       if(t == 0){
        //         return '正常';
        //       }else if(t == 1){
        //         return '充电过温'
        //       }
        //     }
        //   },
        //   {
        //     title:'创建时间',
        //     align:"center",
        //     dataIndex: 'createTime'
        //   },
        // ],
        // columns3: [
        //   {
        //     title: '#',
        //     dataIndex: '',
        //     key:'rowIndex',
        //     width:60,
        //     align:"center",
        //     customRender:function (t,r,index) {
        //       return parseInt(index)+1;
        //     }
        //   },
        //   {
        //     title:'设备id',
        //     align:"center",
        //     dataIndex: 'meterId'
        //   },
        //   {
        //     title:'是否放电',
        //     align:"center",
        //     dataIndex: 'isDischarging',
        //     customRender:function (t,r,index) {
        //       if(t == 0){
        //         return '未放电';
        //       }else if(t == 1){
        //         return '正在放电'
        //       }
        //     }
        //   },
        //   {
        //     title: '是否硬件保护',
        //     dataIndex: 'isHardwareProtection',
        //     align:"center",
        //     customRender:function (t,r,index) {
        //       if(t == 0){
        //         return '正常';
        //       }else if(t == 1){
        //         return '硬件保护'
        //       }
        //     }
        //   },
        //   {
        //     title:'是否开路保护',
        //     align:"center",
        //     dataIndex: 'isOpenCircuitProtection',
        //     customRender:function (t,r,index) {
        //       if(t == 0){
        //         return '正常';
        //       }else if(t == 1){
        //         return '开路保护'
        //       }
        //     }
        //   },
        //   {
        //     title:'是否过温',
        //     align:"center",
        //     dataIndex: 'isOvertemperature',
        //     customRender:function (t,r,index) {
        //       if(t == 0){
        //         return '正常';
        //       }else if(t == 1){
        //         return '放电过温'
        //       }
        //     }
        //   },
        //   {
        //     title:'是否短路保护',
        //     align:"center",
        //     dataIndex: 'isShortCircuitProtection',
        //     customRender:function (t,r,index) {
        //       if(t == 0){
        //         return '正常';
        //       }else if(t == 1){
        //         return '短路保护'
        //       }
        //     }
        //   },
        //   {
        //     title:'设备输出功率',
        //     align:"center",
        //     dataIndex: 'meterOutputPowerState',
        //     customRender:function (t,r,index) {
        //       if(t == 0){
        //         return '轻载';
        //       }else if(t == 1){
        //         return '中度'
        //       }else if(t == 2){
        //         return '额定'
        //       }else if(t == 3){
        //         return '过载'
        //       }
        //     }
        //   },
        //   {
        //     title:'设备状态',
        //     align:"center",
        //     dataIndex: 'meterState',
        //     customRender:function (t,r,index) {
        //       if(t == 0){
        //         return '正常';
        //       }else if(t == 1){
        //         return '故障'
        //       }
        //     }
        //   },
        //   {
        //     title:'创建时间',
        //     align:"center",
        //     dataIndex: 'createTime'
        //   },
        // ],
        url: {
          list: '/jeecg-charge/tyn/solarEnergyMeterBatteryStatus/queryNowById',
          listH1: "/jeecg-charge/tyn/solarEnergyMeterBatteryStatus/queryNowById",
          listH2: "/jeecg-charge/tyn/solarEnergyChargingStatus/queryNowById",
          listH3: "/jeecg-charge/tyn/solarEnergyDischargingStatus/queryNowById",
          listR1: "/jeecg-charge/tyn/solarEnergyMeterBatteryStatus/queryRecordById",
          listR2: "/jeecg-charge/tyn/solarEnergyChargingStatus/queryRecordById",
          listR3: "/jeecg-charge/tyn/solarEnergyDischargingStatus/queryRecordById",
        },
        model:{},
        queryParam:{},
        handleType: ''
      }
    },
    methods: {
      init(row,type){
        this.visible = true;
        this.title = this.$t('状态信息');
        this.disableSubmit = true;
        this.handleType = type;
        if(type == 'realTime'){// 实时数据
          this.queryParam.meterId = row.meterId;
          this.url.list = this.url.listH1;
          this.columns = this.columns1;
        }else{// 历史数据
          this.queryParam.id = row.id;
          this.url.list = this.url.listR1;
          this.columns = this.columns1;
        }
        this.getModel();
      },
      callback(e){
        this.columns = this['columns'+e];
        if(this.handleType == 'realTime'){
          this.url.list = this.url['listH'+e];
        }else{
          this.url.list = this.url['listR'+e];
        }
        this.getModel();
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
      getModel(){
        getAction(this.url.list,this.queryParam).then(res=>{
          if(res.success){
            this.model = res.result;
          }
        })
      }
    }
  }
</script>
